//src/api/axiosInstance.js

import axios from 'axios';
import { getToken, removeAuthData } from '../utils/auth';

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_URL,

  // baseURL: 'https://gurukulapi-dev.finhaat.com:9094/',

  
  headers: {
    'Content-Type': 'application/json',
  },
});

axiosInstance.interceptors.request.use(
  (config) => {
    const token = getToken();
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      removeAuthData();
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);


export default axiosInstance;
